import { useApp } from '../store/AppContext';
import { PlaceholderPage } from './PlaceholderPage';
import { TasksPage } from './TasksPage';

export function NeuralPage() {
  const { ui } = useApp();
  if (ui.scope !== 'bing') {
    return <PlaceholderPage title="AI поиск" />;
  }
  return <TasksPage lane="neuro" />;
}
